import { all } from 'redux-saga/effects';

import { watchGetPaymentIntentAsync } from './sagas/intent';
import { watchCreatePaymentMethodAsync, watchGetAvailablePaymentMethods } from './sagas/paymentMethod';
import {
  watchCheckoutOneOffConfirmAsync,
  watchCheckoutInstrumentConfirmAsync,
  watchCheckoutConfirmForDccAsync,
} from './sagas/confirm';
import { watchPaymentConsentAsync } from './sagas/paymentConsent';
import { watchCreateAttemptQrcodeAsync } from './sagas/attemptQrcode';
import { watchCreateAttemptRedirectAsync } from './sagas/attemptRedirect';
import { watchGetPaymentRequestApiAsync } from './sagas/paymentRequestApi';
import { watchPaymentConsentForRedirectAsync } from './sagas/paymentConsentForRedirect';

export default function* rootSaga() {
  yield all([
    watchGetPaymentIntentAsync(),
    watchCreatePaymentMethodAsync(),
    watchCheckoutOneOffConfirmAsync(),
    watchCheckoutInstrumentConfirmAsync(),
    watchCreateAttemptQrcodeAsync(),
    watchCreateAttemptRedirectAsync(),
    watchGetPaymentRequestApiAsync(),
    watchCheckoutConfirmForDccAsync(),
    watchPaymentConsentAsync(),
    watchPaymentConsentForRedirectAsync(),
    watchGetAvailablePaymentMethods(),
  ]);
}
